import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import {platformBrowser} from "@angular/platform-browser";
import * as Sentry from '@sentry/angular';

import { environment } from './environments/environment';
import {BekocheckModule} from './app/bekocheck/bekocheck.module';

Sentry.init({
  dsn: 'https://118c7f2e4ce3441da1333df98730f120@sentry.co2online.de/5',
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'fetch' && breadcrumb.data && breadcrumb.data.url && breadcrumb.data.url.match(/^data/)) {
      return null;
    }
    return breadcrumb;
  },

  enabled: environment.production === true,

  environment: window.location.host.indexOf('-dev') > 0? 'stage' : 'production',

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(BekocheckModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
